<template>
    <div>
        <div class="config-wrapper">
            <div class="config">
                <div class="title">{{ state.commonConfig.label }}</div>
                <div class="content">
                    <div v-for="config in commonConfig.children" :key="config.key" class="sub-content">
                        <div class="sub-title">{{ config.label }}</div>
                        <el-tree ref="ref_common_tree" :data="config.children" show-checkbox node-key="id"
                            :expand-on-click-node="false" @check="handleCommonCheck" class="no-leaf">
                        </el-tree>
                    </div>
                </div>
            </div>
            <div class="config">
                <div class="title">{{ state.otherConfig.label }}</div>
                <div class="content">
                    <div v-for="config in otherConfig.children" :key="config.key" class="sub-content">
                        <div class="sub-title">{{ config.label }}</div>
                        <el-tree ref="ref_other_tree" :data="config.children" show-checkbox node-key="id"
                            :expand-on-click-node="false" @check="handleCheck" class="no-leaf mr-15">
                        </el-tree>
                    </div>
                </div>
            </div>
            <div class="config">
                <div class="title">{{ state.topicChannelConfig.label }}</div>
                <div class="content">
                    <div v-for="config in topicChannelConfig.children" :key="config.key" class="sub-content">
                        <div class="sub-title">{{ config.label }}</div>
                        <el-tree ref="ref_channel_tree" :data="config.children" show-checkbox node-key="id"
                            :expand-on-click-node="false" @check="handleTopicCheck"
                            :default-checked-keys="topicCheckedKeys" class="no-leaf mr-15">
                        </el-tree>
                    </div>
                </div>
            </div>
            <div class="config">
                <div class="title">{{ state.ganzhiConfig.label }}</div>
                <div class="content">
                    <div v-for="config in ganzhiConfig.children" :key="config.key" class="sub-content">
                        <div class="sub-title">{{ config.label }}</div>
                        <el-tree ref="ref_ganzhi_tree" :data="config.children" show-checkbox node-key="id"
                            :expand-on-click-node="false" @check="handleGanzhiCheck"
                            :default-checked-keys="ganzhiConfig_checksKeys" class="no-leaf mr-15">
                        </el-tree>
                    </div>
                </div>
            </div>
        </div>
        <ElFormItem label="Bumper信息:" prop="version">
            <div v-for="item in bumperDataList" :key="item.label">
                <ElTag :type="item.type" :style="item.style">
                    {{ item.label }}
                </ElTag>
            </div>
        </ElFormItem>
    </div>
</template>

<script setup lang="ts">
import {
    ref,
    defineComponent,
    onMounted,
    reactive,
    PropType,
    watch,
} from 'vue';
import {
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
    ElCheckbox,
    ElButton,
    ElRow,
    ElTag,
    ElSwitch
} from 'element-plus';
import { useStore } from '@/store';
import { useFrameDataStore } from "@/store/frameDataStore";
import { useVisibleChannelStore } from '@/store/visibleChannelStore'
import { commonConfig, otherConfig, initOhterList, initCommonChecks, topicChannelConfig, ganzhiConfig, initEraseChannelIds } from './data';

let frameDataStore = useFrameDataStore();
const eventTagList = ref([]);
const bumperDataList = ref([])
const visibleChannelStore = useVisibleChannelStore();
const ref_other_tree = ref();
const ref_common_tree = ref();
const ref_channel_tree = ref()
const ref_ganzhi_tree = ref()
const topicCheckedKeys = ref(readTopicCheckedKeys())
const ganzhiConfig_checksKeys = ref()

const store = useStore();
const state = reactive({
    commonConfig,
    otherConfig,
    topicChannelConfig,
    ganzhiConfig
})

const formData = reactive({
    form: {
        checkedEventTags: store.state.checkedEventTags,
        isCheckedAllEventTags: false,
    },
});

onMounted(() => {
    handleLoadOtherChecks();
    loadCommonListChecks();
    loadTopicListChecks();
    loadganzhiConfig();
});
function loadCommonListChecks() {
    try {
        let config_CommonListChecks_str = localStorage.getItem('config_CommonListChecks');
        if (config_CommonListChecks_str) {
            handleSetCommonChecks(JSON.parse(config_CommonListChecks_str));
            handleCommonCheck();
        } else {
            handleSetCommonChecks(initCommonChecks);
            localStorage.setItem('config_CommonListChecks', JSON.stringify(initCommonChecks));
            visibleChannelStore.setConfig_CommonListChecks(initCommonChecks);
        }
    } catch (ex) {
        console.log(ex);
    }
}
function readTopicCheckedKeys() {
    let keys = [];
    const raw = localStorage.getItem('topicChannelChecks');
    if (raw) {
        try {
            const parsed = JSON.parse(raw);
            keys = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            keys = [];
        }
    }
    if (!localStorage.getItem('eraseVisualConfigInited')) {
        keys = Array.from(new Set([...keys, ...initEraseChannelIds]));
        localStorage.setItem('topicChannelChecks', JSON.stringify(keys));
        localStorage.setItem('eraseVisualConfigInited', '1');
    }
    return keys;
}
const loadTopicListChecks = () => {
    topicCheckedKeys.value = readTopicCheckedKeys();
    visibleChannelStore.setTopicChannelChecks(topicCheckedKeys.value);
}
const loadganzhiConfig = () => {
    let ganzhiConfig_checks = localStorage.getItem('ganzhiConfig_checks');
    if (ganzhiConfig_checks) {
        ganzhiConfig_checksKeys.value = JSON.parse(ganzhiConfig_checks)
        visibleChannelStore.setGanzhilChecks(ganzhiConfig_checksKeys.value);
    } else {
        let checkedKeys = ['/ganzhiConfig/ObstacleNegType/0',
            '/ganzhiConfig/ObstacleNegType/1',
            '/ganzhiConfig/ObstacleNegType/2',
            '/ganzhiConfig/ObstacleNegType/3',
            '/ganzhiConfig/ObstacleNegType/4'
        ]
        ganzhiConfig_checksKeys.value = checkedKeys
        localStorage.setItem('ganzhiConfig_checks', JSON.stringify(checkedKeys));
        visibleChannelStore.setGanzhilChecks(checkedKeys);
    }
}
const handleLoadOtherChecks = () => {
    let otherConfigCheckList = [] as any;
    initOhterList.forEach((item) => {
        let config = localStorage.getItem(item);
        if (config == "1") {
            otherConfigCheckList.push(item);
        }
    })
    ref_other_tree.value[0].setCheckedKeys(otherConfigCheckList);
    visibleChannelStore.setFreeArea(otherConfigCheckList.includes('freeArea_enabled'));
}

const handleSetCommonChecks = (checks: any) => {
    for (let i = 0; i < ref_common_tree.value.length; i++) {
        if (!checks[i]) break;
        ref_common_tree.value[i].setCheckedKeys(checks[i]);
    }
}
const handleCommonCheck = () => {
    let checks_list_common = []
    for (let i = 0; i < ref_common_tree.value.length; i++) {
        checks_list_common.push(ref_common_tree.value[i].getCheckedKeys());
    }
    visibleChannelStore.setConfig_CommonListChecks(checks_list_common);
    localStorage.setItem('config_CommonListChecks', JSON.stringify(checks_list_common));
}

const handleTopicCheck = () => {
    const checkedKeys = [];
    ref_channel_tree.value?.forEach((tree) => {
        checkedKeys.push(...tree.getCheckedKeys());
    });
    localStorage.setItem('topicChannelChecks', JSON.stringify(checkedKeys));
    visibleChannelStore.setTopicChannelChecks(checkedKeys);
}

const handleGanzhiCheck = (checkedValue: any, checkedInfo: any,) => {
    let { checkedKeys } = checkedInfo
    localStorage.setItem('ganzhiConfig_checks', JSON.stringify(checkedKeys));
    visibleChannelStore.setGanzhilChecks(checkedKeys);
}

watch(
    () => formData.form.isCheckedAllEventTags,
    (isCheckedAllEventTags) => {
        if (isCheckedAllEventTags) {
            formData.form.checkedEventTags = eventTagList.value.map(
                ({ id }) => id,
            );
        } else {
            if (
                formData.form.checkedEventTags.length === eventTagList.value.length
            ) {
                formData.form.checkedEventTags = [];
            }
        }
    },
);

watch(() => frameDataStore.currentData, (formData) => {
    if (formData?.vehicleBumper?.bumperList?.length > 0) {
        bumperDataList.value = formData?.vehicleBumper?.bumperList.map((item: any) => {
            return buildBumperInfo(item)
        })
    }
});
function buildBumperInfo(item: any) {
    if (item.switchDisable) {
        item.type = "info";
    }
    if (item.switchTouched) {
        item.type = "danger";
        item.style = "font-size:20px;font-weight: 900; margin-left: 12px; color: red;"
    } else {
        item.type = "success";
        item.style = "font-size:14px;margin-left: 12px"
    }
    let label = 'None';
    switch (item.position) {
        case 1:
            label = '底盘-前'; break;
        case 2:
            label = '底盘-后'; break;
        case 3:
            label = '底盘-左'; break;
        case 4:
            label = '底盘-右'; break;
        case 5:
            label = '货箱-上'; break;
        case 6:
            label = '货箱-下'; break;
        case 7:
            label = '虚拟'; break;
    }
    item.label = label;
    return item;
}

const handleCheck = (data: any, checked: any) => {
    const isChecked = checked.checkedKeys.includes(data.id);
    localStorage.setItem(data.id, isChecked ? "1" : "0");
    visibleChannelStore.setGlobalMap(checked.checkedKeys.includes('GlobalMap_local'));
    visibleChannelStore.setLocalMap(checked.checkedKeys.includes('localMap_local'));
    visibleChannelStore.setVirtualLane(checked.checkedKeys.includes('virtualLane_local'));
    visibleChannelStore.setCrossWalk(checked.checkedKeys.includes('cross_walk_local'));
    visibleChannelStore.setObstaclLabelStatic(checked.checkedKeys.includes('obstacl_label_local_static'));
    visibleChannelStore.setGpsTrajectory(checked.checkedKeys.includes('gps_trajectory_local'));
    visibleChannelStore.setFreeArea(checked.checkedKeys.includes('freeArea_enabled'));

    if (checked.checkedKeys.includes('cross_walk_local')) {
        visibleChannelStore.setGlobalMap(true);
        localStorage.setItem('GlobalMap_local', "1");
        ref_other_tree.value[0].setChecked('GlobalMap_local', true);
    }

    if (data.id === 'GlobalMap_local' && !isChecked && checked.checkedKeys.includes('cross_walk_local')) {
        ref_other_tree.value[0].setChecked('cross_walk_local', false);
        ref_other_tree.value[0].setChecked('GlobalMap_local', false);
        localStorage.setItem('cross_walk_local', "0");
        localStorage.setItem('GlobalMap_local', "0");
        visibleChannelStore.setCrossWalk(false);
    }
}

</script>

<style scoped lang="less">
.config-wrapper {
    margin-bottom: 10px;
    padding: 5px;

    .config {
        padding: 5px 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        margin-bottom: 5px;

        &:last-child {
            border-bottom: none;
            margin-bottom: 0;
        }

        .title {
            margin: 0 0 6px 0;
            padding-bottom: 4px;
            text-align: left;
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        }

        .content {
            width: 100%;
            display: flex;
            justify-content: start;

            .sub-title {
                color: rgba(255, 255, 255, 0.85);
                font-size: 13px;
                margin-bottom: 4px;
                font-weight: 500;
            }

            .sub-content {
                width: 100%;
               
            }

            :deep(.el-tree) {
                background: transparent;
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 4px 10px;
                width: 100%;

                .el-tree-node {
                    display: flex;
                }

                .el-tree-node__content {
                    background: transparent;
                    color: #fff;
                    height: auto;
                    min-height: 26px;
                    padding: 3px 6px;
                    display: flex;
                    align-items: center;
                    border-radius: 4px;
                    width: 100%;

                    &:hover {
                        background-color: rgba(255, 255, 255, 0.08);
                    }

                    .el-tree-node__label {
                        font-size: 13px;
                        line-height: 1.4;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .el-checkbox {
                        margin-right: 6px;
                        display: flex;
                        align-items: center;
                        flex-shrink: 0;

                        .el-checkbox__inner {
                            border-color: rgba(255, 255, 255, 0.5);
                        }

                        .el-checkbox__label {
                            color: #fff;
                            padding-left: 6px;
                        }
                    }
                }

                .el-tree-node__children {
                    display: contents;
                }
            }
        }
    }
}

.no-leaf {
    :deep(.el-icon.el-tree-node__expand-icon.is-leaf) {
        display: none;
    }
}

.mr-15 {
    :deep(.el-tree-node__content) {
        margin-right: 0;
    }
}

// Bumper信息样式优化
:deep(.el-form-item) {
    margin-bottom: 15px;

    .el-form-item__label {
        color: #fff;
        font-weight: 500;
    }

    .el-tag {
        margin: 4px 8px 4px 0;
    }
}
</style>